exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step--details h1.heading-1{font-size:20px;margin-bottom:2rem;line-height:1.5}@media (min-width:1024px){.step--details h1.heading-1{font-size:24px}}.step--details .flights-info{background-color:transparent}.step--details .flights-info .booking-box{padding:0}.step--details .flights-info .flight-box{padding:1.8rem 16px}@media (min-width:640px){.step--details .flights-info .flight-box{padding:1.8rem 2.2rem}}.step--details .flights-info .flight-box:last-child{border-top:1px solid #979797}@media (min-width:1024px){.step--details .flights-info .flight-box>div:first-child{width:12rem;flex-grow:0}}.step--details .flights-info .flight-box img{width:43px}.step--details .banner--icon .banner-content{margin-left:1rem}.step--details .banner--icon .banner-content .banner-title{font-size:1rem}.step--details .banner--icon .banner-copy{font-size:.9rem}.step--details .avm-btn{margin-top:5rem}@media screen and (min-width:1024px){.step--details .banner--icon .banner-content{margin-left:2.8rem}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};